import React, { Component, createContext } from 'react';
import classNames from 'classnames';
import { FormContext } from '@anwb/form';
import { FormBlockContainer, FormBlockFieldSet, FormBlockLabel } from './styles/form-block.styled';
export const FormBlockContext = createContext({
    handlerState: () => { },
});
/**
 * The FormBlock component will help render a set of form fields
 */
class FormBlock extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            formData: {},
            mounted: false,
        };
        /**
         * This will communicate form state with the form component
         */
        this.handlerState = (formDataChange) => {
            const objKey = Object.keys(formDataChange)[0];
            let updateState = Object.keys(this.state.formData).length === 0;
            if (!updateState) {
                updateState = !Object.keys(this.state.formData).includes(objKey);
            }
            if (!updateState &&
                Object.keys(formDataChange).includes(objKey) &&
                Object.keys(this.state.formData).includes(objKey)) {
                updateState =
                    JSON.stringify(formDataChange[objKey]) !== JSON.stringify(this.state.formData[objKey]);
            }
            if (updateState && this.state.mounted) {
                this.setState((prevState) => ({
                    formData: Object.assign(Object.assign({}, prevState.formData), formDataChange),
                }), this.dispatchHandlerState);
            }
        };
        // Call `this.props.handlerState` with latest formData
        this.dispatchHandlerState = () => {
            const { handlerState } = this.props;
            if (handlerState) {
                handlerState(this.state.formData);
            }
        };
    }
    componentDidMount() {
        this.setState({
            mounted: true,
        });
    }
    componentWillUnmount() {
        this.setState({
            mounted: false,
        });
    }
    render() {
        const { label, border = false, tooltip, children, reference = null, class: reactClassName, } = this.props;
        const formClassNames = classNames(reactClassName, border ? 'PONCHO-form__block--border' : 'PONCHO-form__block');
        return (React.createElement(FormBlockContext.Provider, { value: {
                handlerState: this.handlerState,
            } },
            React.createElement(FormBlockContainer, { className: formClassNames, "$border": border, id: reference },
                React.createElement(FormBlockFieldSet, null,
                    label && (React.createElement(FormBlockLabel, { className: "PONCHO-form__block-label" },
                        label,
                        tooltip)),
                    children))));
    }
}
FormBlock.defaultProps = {
    border: false,
    handlerState: () => { },
};
const FormBlockWithContext = (props) => (React.createElement(FormContext.Consumer, null, ({ handlerState }) => (React.createElement(FormBlock, Object.assign({}, props, { handlerState: handlerState })))));
export default FormBlockWithContext;
//# sourceMappingURL=FormBlock.js.map